<template>
    <div class="permissionsContainer" :key="updateComponentKey">
        <div class="permissionsHeaderContainer">
            <div class="labelContainer">
                <div class="searchContainer">
                    <v-icon> search </v-icon>
                    <InputField inputType="text" :value="search" :placeholder="$t('Search')" :inputStyle="{
                        borderRadius: '0px',
                        width: '300px',
                        border: 'none',
                        padding: '0px',
                    }" @input="handleSearch($event)" />
                </div>
            </div>
            <div class="checkBoxContentPermissions">
                <span class="labelPermissionHeader">{{$t('View')}}</span>
            </div>
            <div class="checkBoxContentPermissions">
                <span class="labelPermissionHeader">{{$t('Create')}}</span>
            </div>
            <div class="checkBoxContentPermissions">
                <span class="labelPermissionHeader">{{$t('Edit')}}</span>
            </div>
            <div class="checkBoxContentPermissions">
                <span class="labelPermissionHeader">{{$t('Delete')}}</span>
            </div>
            <div class="checkBoxContentPermissions" style="border: none">
                <span class="labelPermissionHeader">{{$tc('Other', 2)}}</span>
            </div>
        </div>
        <div v-for="(permissions, index) in data" :key="permissions.label">
            <div class="expantionHeaderContainer">
                <div class="labelContainer" @click="expandClick(index)">
                    <v-icon v-if="expandOrders[index]" class="expandIcon">
                        expand_more
                    </v-icon>
                    <v-icon v-else class="expandIcon">
                        expand_less
                    </v-icon>
                    <span class="label">{{ $t("permissions.types."+permissions.label) }}</span>
                </div>
                <div
                  v-for="(columnName, columnIndex) in columnNames"
                  class="checkBoxContent"
                  :class="{ 'lastCheckbox': columnIndex === checkboxes.length - 1 }"
                  :key="columnName"
                >
                  <InputField
                    v-if="hideCheckboxHeaders && checkboxesArray.length > 0 && checkboxesArray[index][columnIndex] !== null"
                    :key="updateComponentKey"
                    inputType="checkbox"
                    :value="checkboxesArray[index][columnIndex]"
                    :checkboxOptions="[{ id: `test${columnIndex + 1}` }]"
                    :inputFieldContainerStyling="{ padding: '2px' }"
                    :indeterminate="isColumnIndeterminate(index, columnName, columnIndex)"
                    :input-disabled="disabled"
                    @input="toggleAllCheckboxes(index, columnIndex)">
                  </InputField>
                </div>
            </div>
            <div v-for="(item, checkboxIndex) in permissions.items" v-if="!expandOrders[index]" class="expansionContent" :key="item.label">
                <div class="labelContent">
                    <span class="permissionsSpan">{{ $t(item.label) }}</span>
                </div>
                <div
                  class="checkBoxContent" v-for="(property, propertyIndex) in columnNames"
                  :class="{ 'lastCheckbox': propertyIndex === 4 }"
                  :key="property"
                >
                  <InputField
                    v-if="item[property] !== null"
                    :key="propertyIndex"
                    inputType="checkbox"
                    :value="item[property]"
                    :checkboxOptions="[{ id: `test${propertyIndex + 1}` }]"
                    :input-disabled="disabled"
                    :inputFieldContainerStyling="{ padding: '2px' }"
                    @input="handleCheckboxChange(index, checkboxIndex, property)">
                  </InputField>
                </div>
            </div>
            <div class="expansionContentLine">
                <div class="labelContent">
                </div>
                <div v-for="(checked, index) in checkboxes" class="checkBoxContent" :key="checked"
                    :class="{ 'lastCheckbox': index === checkboxes.length - 1 }">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomButton from './CustomButton.vue';
import InputField from './InputField.vue';
import _ from 'lodash';

export default {
    name: "PermissionMatrix",

    components: { CustomButton, InputField },

    props: {
        data: {
            type: Array,
        },

        disabled: {
          type: Boolean,
        },
    },

    data() {
        return {
            columnNames: ['view', 'create', 'edit', 'delete', 'other'],
            expandOrders: Array(this.data.length).fill(null),
            checkboxes: [false, false, false, false, false],
            search: null,
            checkboxesArray: [],
            originalData: this.data,
            updateComponentKey: 1,
            hideCheckboxHeaders: true,
        }
    },

    computed: {
        isColumnIndeterminate() {
            return (index, columnName, checkboxIndex) => {
                const fileteredColumnValues = this.data[index].items.map(item => item[columnName]);
                const columnValues = fileteredColumnValues.filter(value => value !== null)
                const flattenedValues = columnValues.flat();
                const allTrue = flattenedValues.every(value => value);
                const someTrue = flattenedValues.some(value => value);

                if (flattenedValues.length === 0) {
                  this.checkboxesArray[index][checkboxIndex] = null;
                } else {
                  if (allTrue) {
                      this.checkboxesArray[index][checkboxIndex] = true;
                  } else if (someTrue) {
                      this.checkboxesArray[index][checkboxIndex] = true;
                  } else {
                      this.checkboxesArray[index][checkboxIndex] = false;
                  }
                }

                return !allTrue && someTrue;
            };
        },
    },

    mounted() {
        if (this.checkboxesArray.length === 0) {
            this.checkboxesArray = Array.from({ length: this.data.length }, () =>
                Array.from({ length: this.columnNames.length }, () => false)
            );
        }
        this.performCheckboxLogic()
    },

    methods: {
        performCheckboxLogic() {
            const result = this.columnNames.map((columnName, checkboxIndex) => {
                const rowIndexValues = this.data.map((item, rowIndex) => {
                    const fileteredColumnValues = item.items.map(subItem => subItem[columnName]);
                    const columnValues = fileteredColumnValues.filter(value => value !== null);
                    const allTrue = columnValues.every(value => value);
                    const someTrue = columnValues.some(value => value);

                    if (columnValues.length === 0) {
                      this.checkboxesArray[rowIndex][checkboxIndex] = null;
                    } else {
                      if (this.checkboxesArray[rowIndex][checkboxIndex] !== null) {
                        if (allTrue) {
                            this.checkboxesArray[rowIndex][checkboxIndex] = true;
                            return true;
                        } else if (someTrue) {
                            this.checkboxesArray[rowIndex][checkboxIndex] = true;
                            return true;
                        } else {
                            this.checkboxesArray[rowIndex][checkboxIndex] = false;
                            return false;
                        }
                      }
                    }
                });
                this.updateComponentKey++
                return rowIndexValues.some(value => value);
            });
        },

        expandClick(index) {
            this.$set(this.expandOrders, index, !this.expandOrders[index]);
        },

        handleCheckboxChange(rowIndex, checkboxIndex, property) {
            const currentItem = this.data[rowIndex].items[checkboxIndex];
            currentItem[property] = !currentItem[property];

            const fileteredColumnValues = this.data[rowIndex].items.map(item => item[property]);
            const columnValues = fileteredColumnValues.filter(item => item !== null);
            const allTrue = columnValues.every(value => value);
            const someTrue = columnValues.some(value => value);

            if (columnValues.length === 0) {
              this.checkboxesArray[rowIndex][checkboxIndex] = null;
            } else {
              if (allTrue) {
                  this.checkboxesArray[rowIndex][checkboxIndex] = true;
              } else if (someTrue) {
                  this.checkboxesArray[rowIndex][checkboxIndex] = true;
              } else {
                  this.checkboxesArray[rowIndex][checkboxIndex] = false;
              }
            }
            this.performCheckboxLogic()
            this.updateComponentKey++
            this.$emit("change");
        },

        toggleAllCheckboxes(permissionsIndex, columnIndex) {
            const columnName = this.columnNames[columnIndex];
            const currentState = this.checkboxesArray[permissionsIndex][columnIndex];

            const fileteredColumnValues = this.data[permissionsIndex].items.map(item => item[columnName]);
            const columnValues = fileteredColumnValues.filter(item => item !== null)
            const allTrue = columnValues.every(value => value);
            const someTrue = columnValues.some(value => value);

            if (allTrue && columnValues.length > 0) {
                this.checkboxesArray[permissionsIndex][columnIndex] = false;
                this.data[permissionsIndex].items.forEach((item) => {
                    if (item[columnName] !== null) {
                      this.$set(item, columnName, false);
                    }
                });
            } else if (someTrue) {
                this.checkboxesArray[permissionsIndex][columnIndex] = true;
                this.data[permissionsIndex].items.forEach((item) => {
                  if (item[columnName] !== null) {
                    this.$set(item, columnName, true);
                  }
                });
            } else {
                this.checkboxesArray[permissionsIndex][columnIndex] = true;
                this.data[permissionsIndex].items.forEach((item) => {
                    if (item[columnName] !== null) {
                      this.$set(item, columnName, true);
                    }
                });
            }

            if (columnValues.length === 0) {
              this.checkboxesArray[permissionsIndex][columnIndex] = null;
            }

            this.performCheckboxLogic()
            this.updateComponentKey++;
            this.$emit("change");
        },

        handleSearch: _.debounce(function (event) {
            if (event === "" || event === null) {
                this.search = null;
                this.hideCheckboxHeaders = true;
                this.data = [...this.originalData];
            } else {
                
                this.search = event;
                this.hideCheckboxHeaders = false;
                this.data = this.originalData.map(item => {
                    const filteredItems = item.items.filter(subItem => {
                        // Translate the label and compare with search text
                        const translatedLabel = this.$t(subItem.label).toLowerCase();
                        return translatedLabel.includes(this.search.toLowerCase());
                    });
                    return { ...item, items: filteredItems };
                });
            }
        }, 1000)
    }
};
</script>

<style scoped>
.permissionsContainer {
    border-radius: 8px;
    border: 1px solid #DBDBE0;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
}

.expantionHeaderContainer {
    display: flex;
    height: 32px;
    width: 100%;
    background: var(--app-primary-tint-800);
    align-items: center;
    justify-content: space-between;

}

.expansionContent {
    height: 32px;
    display: flex;
    width: 100%;
    border-top: 1px solid #DBDBE0;
}

.expansionContentLine {
    height: 3px;
    display: flex;
    width: 100%;
}

.expandIcon {
    height: 15px;
    width: 15px;
    margin-left: 5px;
    margin-right: 5px;
    cursor: pointer;
}

.labelContainer {
    height: 100%;
    width: 50.2%;
    display: flex;
    align-items: center;
    border-right: 1px solid #DBDBE0;
}

.checkBoxContainer {
    display: flex;
}

.labelContent {
    display: flex;
    align-items: center;
    width: 50.2%;
    justify-content: flex-start;
    border-right: 1px solid #DBDBE0;
}

.permissionsSpan {
    margin-left: 21px;
    color: #767676;
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.permissionsHeaderContainer {
    display: flex;
    height: 32px;
    width: 100%;
    align-items: center;
    justify-content: space-between;
}

.checkBoxContentPermissions {
    height: 100%;
    width: 9.96%;
    display: flex;
    align-items: center;
    border-right: 1px solid #DBDBE0;
    justify-content: center;
}

.checkBoxContent {
    height: 100%;
    width: 9.96%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #DBDBE0;
}

.lastCheckbox {
    border-right: none;
    width: 9.96%;
    display: flex;
    align-items: center;
    height: 100%;
}

.labelPermissionHeader {
    color: #767676;
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 10px;
}

.searchContainer {
    display: flex;
    align-items: center;
    margin-left: 5px
}

.label {
    color: #767676;
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 10px;
    text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/_Atoms/PermissionMatrix.vue